import { Routes } from '@angular/router';
import { PageTitleEnum } from '@shared/enums';
import { userGuard } from '@core/guards';

export const orderSetupRoutes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('./_order-setup-layout/order-setup-layout.component').then(mod => mod.OrderSetupLayoutComponent),
        children: [
            {
                path: '',
                redirectTo: 'strain-selection',
                pathMatch: 'full',
            },
            {
                path: 'strain-selection',
                loadComponent: () =>
                    import('./order-setup-strain-selection/order-setup-strain-selection.component').then(
                        mod => mod.OrderSetupStrainSelectionComponent
                    ),
                canActivate: [userGuard],
                title: PageTitleEnum.ORDER_SETUP_STRAIN_SELECTION,
                data: { preload: true },
            },
            {
                path: 'sample-entry',
                loadComponent: () =>
                    import('./order-setup-sample-entry/order-setup-sample-name-entry.component').then(
                        mod => mod.OrderSetupSampleNameEntryComponent
                    ),
                canActivate: [userGuard],
                title: PageTitleEnum.ORDER_SETUP_SAMPLE_ENTRY,
            },
            {
                path: 'finalize-order',
                loadComponent: () =>
                    import('./order-setup-finalize/order-setup-finalize.component').then(
                        mod => mod.OrderSetupFinalizeComponent
                    ),
                canActivate: [userGuard],
                title: PageTitleEnum.ORDER_SETUP_FINALIZE_ORDER,
            },
        ],
    },
    {
        path: 'confirmation',
        loadComponent: () =>
            import(
                '../../shared-features/order-setup/components/order-setup-confirmation/order-setup-confirmation.component'
            ).then(mod => mod.OrderSetupConfirmationComponent),
        canActivate: [userGuard],
        title: PageTitleEnum.ORDER_SETUP_CONFIRMATION_ORDER,
    },
];
